import AccordionCard from './AccordionCard';
export default AccordionCard;
